import { createAsyncThunk } from "@reduxjs/toolkit";

import * as api from "shared/api/methods";

import * as types from "./types";

export const getCourseById = createAsyncThunk<any, any>(
  types.GET_COURSE_BY_ID,
  async ({ courseId }: any) => {
    const course = await api.getCourse(courseId);

    return course;
  }
);
